export default "__VITE_ASSET__Dt3Q3qVM__"